import moment from "moment";
import { globalTheme } from "../MakersV2/Theme/Theme";
import { Flexbox, FlipCardScene, FrontFace, WrapperBox } from "../MakersV2/Theme/GlobalStyles";

const convertToSlot = (start_time, end_time) => {
  // Parse input times as Moment objects
  const startTime = moment.utc(start_time);
  const endTime = moment.utc(end_time);

  // Calculate duration in minutes
  const duration = moment.duration(endTime.diff(startTime));

  // Format start and end times in the desired format
  const startTimeString = startTime.format("hh:mm A");
  const endTimeString = endTime.format("hh:mm A");

  // Access the duration in minutes using the `asMinutes` method
  const durationMinutes = duration.asMinutes();

  // Create the time slot string
  const timeSlotString = `${startTimeString} - ${endTimeString} (${durationMinutes} minutes)`;

  return timeSlotString;
};

const convertToSlotWithoutMin = (start_time, end_time) => {
  const startDate = new Date(start_time);
  const endDate = new Date(end_time);
  const startTimeString = startDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const endTimeString = endDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const timeSlotString = `${startTimeString} - ${endTimeString}`;
  // console.log(timeSlotString);
  return timeSlotString;
};

// const convertTo30MinSlots = (startTime, endTime) => {
//   let thirtyMinSlots = [];
//   let start = moment.utc(startTime);
//   let end = moment.utc(endTime);

//   while (start.isBefore(end)) {
//     let nextStart = moment(start).add(30, "minutes");
//     thirtyMinSlots.push(
//       `${start.format("HH:mm")} - ${nextStart.format("HH:mm")}`
//     );
//     start = nextStart;
//   }

//   return thirtyMinSlots;
// };


const convertTo30MinSlots = (startTime, endTime) => {
  let thirtyMinSlots = [];
  let start = moment.utc(startTime);
  let end = moment.utc(endTime);

  while (start.isBefore(end)) {
    let nextStart = moment(start).add(30, "minutes");
    thirtyMinSlots.push(
      `${start.format("HH:mm")} - ${nextStart.isAfter(end) ? end.format("HH:mm") : nextStart.format("HH:mm")}`
    );
    start = nextStart;
  }

  return thirtyMinSlots;
};

const convertTo15MinSlots = (startTime, endTime) => {
  let slots = [];
  let start = moment.utc(startTime);
  let end = moment.utc(endTime);

  while (start.isBefore(end)) {
    let nextStart = moment(start).add(15, "minutes");
    slots.push(
      `${start.format("HH:mm")} - ${nextStart.isAfter(end) ? end.format("HH:mm") : nextStart.format("HH:mm")}`
    );
    start = nextStart;
  }

  return slots;
};


const checkFor30MinTimeBeforeBooking = (booking_start_time) => {
  return (
    new Date() >
    new Date(booking_start_time.slice(0, -1)).setMinutes(
      new Date(booking_start_time.slice(0, -1)).getMinutes() - 30
    )
  );
};

const convertTo12HourSlot = (start_time, end_time) => {
  const startDate = new Date(start_time);
  const endDate = new Date(end_time);
  // console.log(startDate, endDate)
  return `${
    moment.utc(startDate, "HH:mm").format("hh:mm")} -
    ${moment.utc(endDate, "HH:mm").format("hh:mma")
  }`;
};
 //combine slots function
 const combineSlots = (slots) => {
  if (slots.length > 0) {
    let combinedSlots = [];
    let [start, end] = slots[0].split(" - ");

    for (let i = 1; i < slots.length; i++) {
      let [tempStart, tempEnd] = slots[i].split(" - ");
      if (end === tempStart) {
        end = tempEnd;
      } else {
        combinedSlots.push(`${start} - ${end}`);
        [start, end] = [tempStart, tempEnd];
      }
    }

    combinedSlots.push(`${start} - ${end}`);
    return combinedSlots;
  }
};


function mergeSlots(slots) {
  // Convert slots to minutes from midnight
  const slotsInMinutes = slots.map(slot => slot.split(' - ').map(time => {
      const [hours, minutes] = time.split(':');
      return parseInt(hours) * 60 + parseInt(minutes);
  }));

  // Sort the slots
  slotsInMinutes.sort((a, b) => a[0] - b[0]);

  // Merge consecutive slots
  const mergedSlots = [slotsInMinutes[0]];
  for (let i = 1; i < slotsInMinutes.length; i++) {
      const lastSlot = mergedSlots[mergedSlots.length - 1];
      const currentSlot = slotsInMinutes[i];

      if (lastSlot[1] >= currentSlot[0]) {
          lastSlot[1] = Math.max(lastSlot[1], currentSlot[1]);
      } else {
          mergedSlots.push(currentSlot);
      }
  }

  // Convert back to time format
  const mergedSlotsInTime = mergedSlots.map(slot => slot.map(minutes => {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }).join(' - '));

  return mergedSlotsInTime;
}

// A booking request stores ONE start_time/end_time pair, so a booking made of
// non-adjacent slots collapses to its outer envelope — picking 12:30 and 1:30
// gets stored as 12:30 → 2:00 and reads as an hour and a half. The
// room_booking_request_slots rows are the faithful record (one row per 30
// minutes), so group those back into contiguous runs before displaying.
const SLOT_MINUTES = 30;

const slotRunsFor = (request) => {
  const starts = (request?.room_booking_request_slots || [])
    .map((s) => moment.utc(s?.slot_time))
    .filter((m) => m.isValid())
    .sort((a, b) => a.valueOf() - b.valueOf());
  if (!starts.length) return [];

  const runs = [];
  let runStart = starts[0];
  let runEnd = starts[0].clone().add(SLOT_MINUTES, "minutes");
  for (let i = 1; i < starts.length; i++) {
    if (starts[i].isSame(runEnd)) {
      // Touches the previous slot — extend the run.
      runEnd = starts[i].clone().add(SLOT_MINUTES, "minutes");
    } else {
      runs.push([runStart, runEnd]);
      runStart = starts[i];
      runEnd = starts[i].clone().add(SLOT_MINUTES, "minutes");
    }
  }
  runs.push([runStart, runEnd]);
  return runs;
};

// "12:30 PM - 01:00 PM, 01:30 PM - 02:00 PM" for a split booking, a single range
// for a contiguous one. Falls back to the request's start/end when the slot rows
// aren't loaded — older rows, or an endpoint that doesn't include them.
const formatBookingTime = (request) => {
  const runs = slotRunsFor(request);
  if (!runs.length) {
    return `${moment.utc(request?.start_time).format("hh:mm A")} - ${moment
      .utc(request?.end_time)
      .format("hh:mm A")}`;
  }
  return runs
    .map(([start, end]) => `${start.format("hh:mm A")} - ${end.format("hh:mm A")}`)
    .join(", ");
};

// Minutes actually booked — the sum of the runs, so a gap between two slots is
// not counted as booked time the way end-minus-start would.
const bookingDurationMinutes = (request) => {
  const runs = slotRunsFor(request);
  if (!runs.length) {
    return moment.utc(request?.end_time).diff(moment.utc(request?.start_time), "minutes");
  }
  return runs.reduce((sum, [start, end]) => sum + end.diff(start, "minutes"), 0);
};

// Map of school name → school id used by the classroom-booking backend.
// Keep this in sync with the school options in RoomCard's School dropdown
// and the AllRoomFilterSlider's status filter.
const SchoolIdsMap = {
  "TETR": "8909170a-95b5-40bc-80d6-222078da5tet",
  "UG": "8909170a-95b5-40bc-80d6-222078da5ug",
  "PGP": "8909170a-65b5-40bc-80d6-222078da5pgp",
  "Exec Education": "8909170a-65b5-40bc-80d6-222078da5dec",
  "Central Functions": "8909170a-95b5-40bc-80d6-222078da5cf",
};

const skeletonStyle = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
  borderRadius: '8px',
};

const SkeletonCard = () => (
  <FlipCardScene>
    <FrontFace>
      <WrapperBox borderRadius={50} padding="14px 14px 20px" borderColor={globalTheme.colors.nuetral2} style={{ height: '100%' }}>
        <div style={{ ...skeletonStyle, width: '100%', height: '160px', borderRadius: '20px' }} />
        <div style={{ ...skeletonStyle, width: '70%', height: '18px', marginTop: '20px' }} />
        <div style={{ ...skeletonStyle, width: '50%', height: '14px', marginTop: '16px' }} />
        <Flexbox className="mb30 mt16" gap={20} alignCenter>
          <div style={{ ...skeletonStyle, width: '80px', height: '14px' }} />
          <div style={{ ...skeletonStyle, width: '140px', height: '14px' }} />
        </Flexbox>
        <div style={{ ...skeletonStyle, width: '100%', height: '8px' }} />
        <div style={{ ...skeletonStyle, width: '100%', height: '40px', marginTop: '30px', borderRadius: '50px' }} />
      </WrapperBox>
    </FrontFace>
  </FlipCardScene>
)

//export function
export {
  convertToSlot,
  convertToSlotWithoutMin,
  convertTo30MinSlots,
  convertTo15MinSlots,
  checkFor30MinTimeBeforeBooking,
  combineSlots,
  mergeSlots,
  convertTo12HourSlot,
  formatBookingTime,
  bookingDurationMinutes,
  slotRunsFor,
  SchoolIdsMap,
  SkeletonCard
};
